export default [
    // *===============================================---*
    // *--------- CHAT  ---------------------------------------*
    // *===============================================---*
    {
        path: '/apps/chats',
        name: 'apps-chats',
        component: () => import('@/views/apps/oldChat/Chats.vue'),
        title: 'چت',
        meta: {
            resource: 'PhoneSupport',
            action: 'PhoneSupport',
            pageTitle: 'چت',
        },
    },
    {
        path: '/apps/chats/:id',
        name: 'apps-chats-id',
        component: () => import('@/views/apps/oldChat/Chat.vue'),
        meta: {
            resource: 'PhoneSupport',
            action: 'PhoneSupport',
            // contentRenderer: 'sidebar-left',
            contentClass: 'chat-application',
        },
    },

    {
        path: '/apps/buy/:id',
        name: 'apps-buy-id',
        component: () => import('@/views/apps/buy/Buy.vue'),
        meta: {
            pageTitle: 'ثبت سفارش کاربر',
            resource: 'Support',
            action: 'Support',
        }
    },

    // *===============================================---*
    // *--------- ECOMMERCE  ---------------------------------------*
    // *===============================================---*
    {
        path: '/apps/e-commerce/students',
        name: 'apps-e-commerce-students',
        component: () => import('@/views/apps/e-commerce/students/StudentsList.vue'),
        meta: {
            resource: 'ProductManager',
            action: 'ProductManager',
        },
    },
    {
        path: '/apps/e-commerce/studentInfoes/:id',
        name: 'apps-e-commerce-studentInfoes',
        component: () => import('@/views/apps/e-commerce/students/StudentInfoes.vue'),
        meta: { resource: 'ProductManager', action: 'ProductManager' },
    },
    {
        path: '/apps/e-commerce/shop',
        name: 'apps-e-commerce-shop',
        component: () => import('@/views/apps/e-commerce/e-commerce-shop/ECommerceShop.vue'),
        meta: {
            contentRenderer: 'sidebar-left-detached',
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'لیست',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/test/question/:id/:title',
        name: 'apps-question-title',
        component: () => import('@/views/apps/test/QuestionList.vue'),
        meta: { resource: 'ProductManager', action: 'ProductManager' },
    },
    {
        path: '/apps/e-commerce/add',
        name: 'apps-e-commerce-add',
        component: () => import('@/views/apps/e-commerce/e-commerce-add/ECommerceAdd.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'افزودن محصول',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/add-course',
        name: 'apps-e-commerce-add-course',
        component: () => import('@/views/apps/e-commerce/e-commerce-add-course/ECommerceAddCourse'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'افزودن دوره',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/packages/create/:id',
        name: 'apps-e-commerce-packages-create-item-id',
        component: () => import('@/views/apps/e-commerce/packages/CreatePackageItem.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'افزودن مدیا',
            //     active: true
            //   },
            // ],
        },
    },

    {
        path: '/apps/e-commerce/add-product-media/:id',
        name: 'apps-e-commerce-add-product-media',
        component: () => import('@/views/apps/e-commerce/e-commerce-add-product-media/ECommerceAddProductMedia.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'افزودن مدیا',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/add-product-topics/:id',
        name: 'apps-e-commerce-add-product-Topics',
        component: () => import('@/views/apps/e-commerce/e-commerce-add-product-topics/AddTopics.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'افزودن مدیا',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/add-product-media-with-chunk/:id',
        name: 'apps-e-commerce-add-product-media-with-chunk',
        component: () => import('@/views/apps/e-commerce/e-commerce-add-product-media/EcommerceAddProductMediaWithChunk.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'افزودن مدیا',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/AddMediaToTest/:id',
        name: 'apps-e-commerce-AddMediaToTest',
        component: () => import('@/views/apps/e-commerce/e-commerce-add-product-media/AddMediaToTest.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'افزودن مدیا',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/add-product-comment/:id',
        name: 'apps-e-commerce-add-product-comment',
        component: () => import('@/views/apps/e-commerce/e-commerce-add-excel-comment/ECommerceAddProductcomment.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            resource: 'ProductManager',
            action: 'ProductManager',
        },
    },
    {
        path: '/apps/e-commerce/ProductCommentById/:id',
        name: 'apps-e-commerce-ProductCommentById',
        component: () => import('@/views/apps/e-commerce/comments/ProductCommentById.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            resource: 'ProductManager',
            action: 'ProductManager',
        },
    },
    {
        path: '/apps/e-commerce/packages/list/:id',
        name: 'apps-e-commerce-packages-list-id',
        component: () => import('@/views/apps/e-commerce/e-commerce-shop/PackagesList.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'افزودن مدیا',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/courses',
        name: 'apps-e-commerce-courses',
        component: () => import('@/views/apps/e-commerce/courses/CoursesList.vue'),
        meta: {
            // pageTitle: 'دوره ها',
            contentClass: 'ecommerce-application',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'محصولات',
            //   },
            //   {
            //     text: 'لیست دوره ها',
            //     active: true,
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/comments',
        name: 'apps-e-commerce-comments',
        component: () => import('@/views/apps/e-commerce/comments/ProductComments'),
        meta: {
            // pageTitle: 'نظرات',
            contentClass: 'ecommerce-application',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'محصولات',
            //   },
            //   {
            //     text: 'لیست نظرات',
            //     active: true,
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/comments/:id',
        name: 'apps-e-commerce-comments-edit',
        component: () => import('@/views/apps/e-commerce/comments/ProductCommentEdit.vue'),
        meta: {
            // pageTitle: 'ویرایش',
            contentClass: 'ecommerce-application',
            resource: 'ProductManager',
            action: 'ProductManager',
            // breadcrumb: [
            //   {
            //     text: 'محصولات',
            //   },
            //   {
            //     text: 'کامنت ها',
            //   },
            //   {
            //     text: 'ویرایش',
            //     active: true,
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/courses/edit/:id',
        name: 'apps-e-commerce-courses-edit',
        component: () => import('@/views/apps/e-commerce/courses/CoursesEdit.vue'),
        meta: {
            // pageTitle: 'دوره ها',
            resource: 'ProductManager',
            action: 'ProductManager',
            contentClass: 'ecommerce-application',
            // breadcrumb: [
            //   {
            //     text: 'محصولات',
            //   },
            //   {
            //     text: 'لیست دوره ها',
            //   },
            //   {
            //     text: 'ویرایش',
            //     active: true,
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/categories',
        name: 'apps-e-commerce-categories',
        component: () => import('@/views/apps/e-commerce/categories/categories-list.vue'),
        meta: {
            resource: 'ProductManager',
            action: 'ProductManager',
            contentClass: 'ecommerce-application',
        },
    },
    {
        path: '/apps/e-commerce/courses/categories',
        name: 'apps-e-commerce-courses-categories',
        component: () => import('@/views/apps/e-commerce/courses/CourseCategories.vue'),
        meta: {
            resource: 'ProductManager',
            action: 'ProductManager',
            contentClass: 'ecommerce-application',
        },
    },
    {
        path: '/apps/e-commerce/categories/edit/:id',
        name: 'apps-e-commerce-categories-edit',
        component: () => import('@/views/apps/e-commerce/categories/categories-edit.vue'),
        meta: {
            resource: 'ProductManager',
            action: 'ProductManager',
            contentClass: 'ecommerce-application',
        },
    },
    // EducationalPost
    {
        path: '/apps/educational-post-list',
        name: 'apps-educational-post-list',
        component: () => import('@/views/apps/e-commerce/e-commerce-shop/ListEducationalPost.vue'),
        meta: {

            contentClass: 'ecommerce-application',
            resource: 'PageAdmin',
            action: 'PageAdmin',
        },
    },
    {
        path: '/apps/educational-post-add',
        name: 'apps-educational-post-add',
        component: () => import('@/views/apps/e-commerce/educational-post/CreateEducationalPost.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    {
        path: '/apps/e-commerce/13',
        name: 'pages-edit-niyayesh',
        component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    {
        path: '/apps/e-commerce/add-product-media-with-chunk/13/1',
        name: 'pages-create-niyayesh',
        component: () => import('@/views/apps/e-commerce/e-commerce-add-product-media/EcommerceAddProductMediaWithChunk.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'PageAdmin',
            action: 'PageAdmin',
            // breadcrumb: [
            //   {
            //     text: 'افزودن مدیا',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/16',
        name: 'pages-edit-tv',
        component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    {
        path: '/apps/e-commerce/add-product-media-with-chunk/16/1',
        name: 'pages-create-tv',
        component: () => import('@/views/apps/e-commerce/e-commerce-add-product-media/EcommerceAddProductMediaWithChunk.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'PageAdmin',
            action: 'PageAdmin',
            // breadcrumb: [
            //   {
            //     text: 'افزودن مدیا',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/21',
        name: 'pages-edit-ghazal-product',
        component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    {
        path: '/apps/e-commerce/add-product-media-with-chunk/21/1',
        name: 'pages-create2-ghazal',
        component: () => import('@/views/apps/e-commerce/e-commerce-add-product-media/EcommerceAddProductMediaWithChunk.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'PageAdmin',
            action: 'PageAdmin',
            // breadcrumb: [
            //   {
            //     text: 'افزودن مدیا',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/add-product-media-with-chunk/14/1',
        name: 'pages-create-meditation',
        component: () => import('@/views/apps/e-commerce/e-commerce-add-product-media/EcommerceAddProductMediaWithChunk.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            // pageTitle: 'محصولات',
            resource: 'PageAdmin',
            action: 'PageAdmin',
            // breadcrumb: [
            //   {
            //     text: 'افزودن مدیا',
            //     active: true
            //   },
            // ],
        },
    },
    {
        path: '/apps/e-commerce/14',
        name: 'pages-edit-meditation',
        component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    {
        path: '/apps/e-commerce/:id',
        name: 'apps-e-commerce-product-details',
        component: () => import('@/views/apps/e-commerce/e-commerce-product-details/ECommerceProductDetails.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            resource: 'ProductManager',
            action: 'ProductManager',
        },
    },
    {
        path: '/apps/educational-post/edit/:id',
        name: 'apps-educational-post-edit',
        component: () => import('@/views/apps/e-commerce/educational-post/EditEducationalPost.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    // Live
    {
        path: '/apps/live-list',
        name: 'apps-live-list',
        component: () => import('@/views/apps/e-commerce/e-commerce-shop/LiveList.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            resource: 'PageAdmin',
            action: 'PageAdmin',
        },
    },
    {
        path: '/apps/live-add',
        name: 'apps-live-add',
        component: () => import('@/views/apps/e-commerce/live/CreateLive.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    {
        path: '/apps/live/edit/:id',
        name: 'apps-live-edit',
        component: () => import('@/views/apps/e-commerce/live/EditLive.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    //   Story
    {
        path: '/apps/story-list',
        name: 'apps-story-list',
        component: () => import('@/views/apps/e-commerce/e-commerce-shop/StoryList.vue'),
        meta: {
            contentClass: 'ecommerce-application',
            resource: 'PageAdmin',
            action: 'PageAdmin',
        },
    },
    {
        path: '/apps/story/add',
        name: 'apps-story-add',
        component: () => import('@/views/apps/e-commerce/story/CreateStory.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    {
        path: '/apps/story/edit/:id',
        name: 'apps-story-edit',
        component: () => import('@/views/apps/e-commerce/story/EditStory.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    //  Coupons
    {
        path: '/apps/coupons/list',
        name: 'apps-coupons-list',
        component: () => import('@/views/apps/coupon/CouponList.vue'),
        meta: {
            resource: 'ProductManager',
            action: 'ProductManager',
        }
    },
    {
        path: '/apps/coupon/add',
        name: 'apps-coupon-add',
        component: () => import('@/views/apps/coupon/CouponAdd.vue'),
        meta: {
            resource: 'ProductManager',
            action: 'ProductManager',
        }
    },
    {
        path: '/apps/coupon/edit/:id',
        name: 'apps-coupon-edit',
        component: () => import('@/views/apps/coupon/CouponEdit.vue'),
        meta: {
            resource: 'ProductManager',
            action: 'ProductManager',
        }
    },
    {
        path: '/apps/coupon/used/:id',
        name: 'apps-coupon-used',
        component: () => import('@/views/apps/coupon/CouponUsed.vue'),
        meta: {
            resource: 'ProductManager',
            action: 'ProductManager',
        }
    },

    //  Seminar
    {
        path: '/apps/seminar/list',
        name: 'apps-seminar-list',
        component: () => import('@/views/apps/seminar/SeminarList.vue'),
        meta: {
            resource: 'ProductManager',
            action: 'ProductManager',
        }
    },
    {
        path: '/apps/seminar/add',
        name: 'apps-seminar-add',
        component: () => import('@/views/apps/seminar/SeminarAdd.vue'),
        meta: {
            resource: 'ProductManager',
            action: 'ProductManager',
        }
    },
    {
        path: '/apps/seminar/trailer',
        name: 'apps-seminar-trailer',
        component: () => import('@/views/apps/seminar/SeminarTrailer.vue'),
        meta: {
            resource: 'ProductManager',
            action: 'ProductManager',
        }
    },
    {
        path: '/apps/seminar/members/:id/:saloonId',
        name: 'apps-seminar-members',
        component: () => import('@/views/apps/seminar/SeminarMembers.vue'),
        meta: { resource: 'ProductManager', action: 'ProductManager' },
    },
    {
        path: '/apps/seminar/setPrice/:id/:saloonId',
        name: 'apps-seminar-setPrice',
        component: () => import('@/views/apps/seminar/SeminarSetPrice.vue'),
        meta: { resource: 'ProductManager', action: 'ProductManager' },
    },
    {
        path: '/apps/seminar/edit/:id/:saloonId',
        name: 'apps-seminar-edit',
        component: () => import('@/views/apps/seminar/SeminarEdit.vue'),
        meta: { resource: 'ProductManager', action: 'ProductManager' },
    },
    {
        path: '/apps/seminar/reserve/:id/:saloonId',
        name: 'apps-seminar-reserve',
        component: () => import('@/views/apps/seminar/SeminarReserve.vue'),
        meta: { resource: 'ProductManager', action: 'ProductManager' },
    },
    {
        path: '/apps/seminar/tickets-by-chair/:id/:saloonId',
        name: 'apps-seminar-ticket-by-chairs',
        component: () => import('@/views/apps/seminar/SeminarTicketsByChair.vue'),
        meta: { resource: 'ProductManager', action: 'ProductManager' },
    },
    {
        path: '/apps/seminar/ticket/:id',
        name: 'apps-seminar-ticket',
        component: () => import('@/views/apps/seminar/SeminarTicket.vue'),
        meta: {
            layout: 'full',
            resource: 'ProductManager',
            action: 'ProductManager',
        },
    },
    //  Posts
    {
        path: '/apps/post/list',
        name: 'apps-post-list',
        component: () => import('@/views/apps/post/PostList.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    {
        path: '/apps/post/edit/:id',
        name: 'apps-post-edit',
        component: () => import('@/views/apps/post/PostEdit.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    {
        path: '/apps/post/comments/:id',
        name: 'apps-post-comments',
        component: () => import('@/views/apps/post/PostComments.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },
    {
        path: '/apps/post/add/media/:id',
        name: 'apps-post-add-media',
        component: () => import('@/views/apps/post/PostAddMedia.vue'),
        meta: { resource: 'PageAdmin', action: 'PageAdmin' },
    },

    //  Edit Pages
    {
        path: '/apps/cache-system',
        name: 'apps-cache-system',
        component: () => import('@/views/apps/edit-pages/CacheSystem.vue'),
        meta: { resource: 'SiteSupport', action: 'SiteSupport' },
    },
    {
        path: '/apps/home-banners',
        name: 'apps-home-banners',
        component: () => import('@/views/apps/edit-pages/HomeBanners.vue'),
        meta: { resource: 'Designer', action: 'Designer' },
    },
    {
        path: '/apps/home-slides',
        name: 'apps-home-slides',
        component: () => import('@/views/apps/edit-pages/HomeSlides.vue'),
        meta: { resource: 'Designer', action: 'Designer' },
    },
    {
        path: '/apps/home-settings',
        name: 'apps-home-settings',
        component: () => import('@/views/apps/edit-pages/Home.vue'),
        meta: { resource: 'SiteSupport', action: 'SiteSupport' },
    },
    {
        path: '/apps/home-seo',
        name: 'apps-home-seo',
        component: () => import('@/views/apps/edit-pages/HomeSeo.vue'),
        meta: { resource: 'SiteSupport', action: 'SiteSupport' },
    },
    {
        path: '/apps/home-mantra',
        name: 'apps-home-mantra',
        component: () => import('@/views/apps/edit-pages/MantraHome.vue'),
        meta: { resource: 'SiteSupport', action: 'SiteSupport' },
    },
    {
        path: '/apps/contactUs',
        name: 'apps-contactUs',
        component: () => import('@/views/apps/edit-pages/contactUs.vue'),
        meta: { resource: 'SiteSupport', action: 'SiteSupport' },
    },
    {
        path: '/apps/selling-services',
        name: 'apps-selling-services',
        component: () => import('@/views/apps/edit-pages/SellingServices.vue'),
        meta: { resource: 'SiteSupport', action: 'SiteSupport' },
    },
    {
        path: '/apps/aboutUs',
        name: 'apps-aboutUs',
        component: () => import('@/views/apps/edit-pages/aboutUs.vue'),
        meta: { resource: 'SiteSupport', action: 'SiteSupport' },
    },
    {
        path: '/apps/tos',
        name: 'apps-tos',
        component: () => import('@/views/apps/edit-pages/Tos.vue'),
        meta: { resource: 'SiteSupport', action: 'SiteSupport' },
    },
    // *===============================================---*
    // *--------- USER ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/apps/admins',
        name: 'apps-admins',
        component: () => import('@/views/apps/admins/admins.vue'),
        meta: { resource: 'Admin', action: 'Admin' },
    },
    {
        path: '/apps/comments/list',
        name: 'apps-comments-list',
        component: () => import('@/views/apps/comments/List.vue'),
        meta: { resource: 'Support', action: 'Support' },
    },
    {
        path: '/apps/users/list',
        name: 'apps-users-list',
        component: () => import('@/views/apps/user/users-list/UsersList.vue'),
        meta: { resource: 'Support', action: 'Support' },
    },
    {
        path: '/apps/users/buyed/:id',
        name: 'apps-users-buyed',
        component: () => import('@/views/apps/user/users-list/UserBuyedItems.vue'),
        meta: { resource: 'Support', action: 'Support' },
    },
    {
        path: '/apps/users/edit/:id',
        name: 'apps-users-edit',
        component: () => import('@/views/apps/user/users-edit/UsersEdit.vue'),
        meta: { resource: 'Support', action: 'Support' },
    },
    {
        path: '/apps/blockedUsers',
        name: 'apps-blocked-users',
        component: () => import('@/views/apps/block/BlockedUsers.vue'),
        meta: { resource: 'Support', action: 'Support' },
    },
    {
        path: '/apps/block',
        name: 'apps-block',
        component: () => import('@/views/apps/block/Block.vue'),
        meta: { resource: 'Support', action: 'Support' },
    },
    {
        path: '/apps/block/user/:id',
        name: 'apps-block-user',
        component: () => import('@/views/apps/block/UserBlock.vue'),
        meta: { resource: 'Support', action: 'Support' },
    },
    {
        path: '/apps/blocked/user/:id',
        name: 'apps-blocked-user',
        component: () => import('@/views/apps/block/UserBlocked.vue'),
        meta: { resource: 'Support', action: 'Support' },
    },

    //  Financial

    {
        path: '/apps/financial/wallets/list',
        name: 'apps-financial-wallets-list',
        component: () => import('@/views/apps/financial/wallets/WalletsList.vue'),
        meta: {
            resource: 'Accountent',
            action: 'Accountent',
        }
    },
    {
        path: '/apps/financial/wallets/info/:id',
        name: 'apps-financial-wallets-info',
        component: () => import('@/views/apps/financial/wallets/WalletInfo.vue'),
        meta: {
            resource: 'Accountent',
            action: 'Accountent',
        }
    },
    {
        path: '/apps/financial/payments/list',
        name: 'apps-financial-payments-list',
        component: () => import('@/views/apps/financial/payments/PaymentsList.vue'),
        meta: {
            resource: 'Accountent',
            action: 'Accountent',
        }
    },
    {
        path: '/apps/financial/bank-cards/list',
        name: 'apps-financial-bank-cards-list',
        component: () => import('@/views/apps/bank-cards/BankCards.vue'),
        meta: {
            resource: 'Accountent',
            action: 'Accountent',
        }
    },
    {
        path: '/apps/orders/list',
        name: 'apps-orders-list',
        component: () => import('@/views/apps/orders/OrdersList.vue'),
        meta: {
            resource: 'Accountent',
            action: 'Accountent',
        }
    },
    {
        path: '/apps/orders/info/:id',
        name: 'apps-orders-info',
        component: () => import('@/views/apps/orders/OrderInfo.vue'),
        meta: {
            resource: 'Accountent',
            action: 'Accountent',
        }
    },
    {
        path: '/apps/orders/receipts/list',
        name: 'apps-orders-receipts-list',
        component: () => import('@/views/apps/orders/receipt/ReceiptsList.vue'),
        meta: {
            resource: 'Accountent',
            action: 'Accountent',
        }
    },
    {
        path: '/apps/receipts/info/:id',
        name: 'apps-receipts-info',
        component: () => import('@/views/apps/orders/receipt/ReceiptInfo.vue'),
        meta: {
            resource: 'Accountent',
            action: 'Accountent',
        }
    },

    // Fortune
    {
        path: '/apps/fortune',
        name: 'apps-fortune',
        component: () => import('@/views/apps/fortune/Fortune.vue'),
        meta: { resource: 'Admin', action: 'Admin' },
    },
    {
        path: '/apps/mantra/list',
        name: 'apps-mantra-list',
        component: () => import('@/views/apps/fortune/MantraList.vue'),
        meta: { resource: 'Admin', action: 'Admin' },
    },
    {
        path: '/apps/mantra/add',
        name: 'apps-mantra-add',
        component: () => import('@/views/apps/fortune/MantraAdd.vue'),
        meta: { resource: 'Admin', action: 'Admin' },
    },
    {
        path: '/apps/mantra/edit/:id',
        name: 'apps-mantra-edit',
        component: () => import('@/views/apps/fortune/MantraEdit.vue'),
        meta: { resource: 'Admin', action: 'Admin' },
    },
    {
        path: '/apps/winners',
        name: 'apps-winners',
        component: () => import('@/views/apps/fortune/Winners.vue'),
        meta: { resource: 'Admin', action: 'Admin' },
    },
    {
        path: '/apps/stickers/list',
        name: 'apps-stickers-list',
        component: () => import('@/views/apps/fortune/StickersList.vue'),
        meta: { resource: 'Admin', action: 'Admin' },
    },

    // Commercials
    {
        path: '/apps/Commercials/NumbersList',
        name: 'apps-commercials-numbers-list',
        component: () => import('@/views/apps/Commercials/NumbersList.vue'),
        meta: { resource: 'Admin', action: 'Admin' },
    },

    // Packages
    {
        path: '/apps/package/list/:id',
        name: 'apps-package-list-id',
        component: () => import('@/views/apps/e-commerce/packages/PackageItemsList.vue'),
        meta: { resource: 'ProductManager', action: 'ProductManager' },
    },
    // Transgressive
    {
        path: '/apps/Transgressive/list',
        name: 'apps-Transgressive-list',
        component: () => import('@/views/apps/Transgressive/TransgressesList.vue'),
        meta: { resource: 'Support', action: 'Support' },
    },
    {
        path: '/apps/Transgressive/users',
        name: 'apps-Transgressive-users',
        component: () => import('@/views/apps/Transgressive/TransgressiveUsers.vue'),
        meta: { resource: 'Support', action: 'Support' },
    },
]
